__turbopack_context__.v({
  "close": "imageModal-module-scss-module__6QrnSa__close",
  "closeButton": "imageModal-module-scss-module__6QrnSa__closeButton",
  "closeContainer": "imageModal-module-scss-module__6QrnSa__closeContainer",
  "embla__button": "imageModal-module-scss-module__6QrnSa__embla__button",
  "embla__button__svg": "imageModal-module-scss-module__6QrnSa__embla__button__svg",
  "embla__button_next": "imageModal-module-scss-module__6QrnSa__embla__button_next",
  "embla__button_prev": "imageModal-module-scss-module__6QrnSa__embla__button_prev",
  "img": "imageModal-module-scss-module__6QrnSa__img",
  "imgModal": "imageModal-module-scss-module__6QrnSa__imgModal",
});
